import React from "react";
import { Link } from "react-router-dom";

export default function Curosel() {
  return (
    <div>
      <div
        id="carouselExampleControls"
        class="carousel slide"
        data-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <Link to="/AllMobile">
              <img
                src="https://rukminim1.flixcart.com/flap/844/140/image/c13b2075bf0deb4e.jpg?q=50"
                class="d-block w-100"
                alt="..."
              />
            </Link>
          </div>
          <div class="carousel-item">
            <Link to="/AllMobile">
              <img
                src="https://rukminim1.flixcart.com/flap/844/140/image/c13b2075bf0deb4e.jpg?q=50"
                class="d-block w-100"
                alt="..."
              />
            </Link>
          </div>
          <div class="carousel-item">
            <Link to="/AllMobile">
              <img
                src="https://rukminim1.flixcart.com/flap/844/140/image/c13b2075bf0deb4e.jpg?q=50"
                class="d-block w-100"
                alt="..."
              />
            </Link>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExampleControls"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleControls"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  );
}
